import { render } from "./WhatsappLink.vue?vue&type=template&id=7b862a40"
import script from "./WhatsappLink.vue?vue&type=script&lang=js"
export * from "./WhatsappLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__